import { getWidthPercentage } from '@/app/utils/helpers';
import HELPER from '@/app/utils/HELPER';
import { AtomTargetHandler } from './AtomTargetHandler';
import type { AtomModel } from '@/app/editor/iframe/atom/Atom.model';
import BaseSettingHandler from './BaseSettingHandler';

/**
 * BaseSettingHandler
 */
export class ShCss extends AtomTargetHandler {
  /**
   * read
   * @param options options
   * @param options.screenType screenType
   * @param options.$activePanel $activePanel
   */
  read(options: { screenType: any; $activePanel: JQuery; $atom: JQuery; atomModel: AtomModel }) {
    this.set$el(options.$atom);
    this.setAtomModel(options.atomModel);
    const targetSelector = this.setting.targetSelector as string;
    const $self = this.getAtomTarget('read', this);
    const style = options.atomModel.style;
    let value: any = '';
    // get value từ data style
    value = HELPER.getValueFromCSS($self, style, this.setting.property, options.screenType, targetSelector);
    if (this.setting.options?.length) {
      for (let i = 0; i < this.setting.options.length; i++) {
        const option = this.setting.options[i];
        if (option.value == value) {
          value = option.key;
        }
      }
    }
    // Nếu không có value thì lấy value tại defaultValue
    // Đối với những case setting cho width hoặc height,
    // nếu muốn giá trị là auto thì cầt set giá trị default_value = auto
    if (!value || value == undefined) {
      value = this.setting.default_value ? this.setting.default_value : '';
    }
    // setting require để lấy css của element
    // check logic cũ, sẽ có 1 số case cần đến css được get từ element này
    if (this.setting.require) {
      const $target = $self.find(targetSelector);
      value = $target.css(this.setting.property);
    }
    // Chuyển đổi value color từ rgb qua hex
    if (this.setting.fieldType == 'color') {
      if (!value || value == 'none') {
        value = this.setting.default_value;
      }
      value = HELPER.rgb2hex(value);
    }
    // Nếu tồn tại value thì check các case đặc biệt bên trong if
    if (value) {
      // convert px to em
      if (this.setting.property == 'line-height' && this.setting.unit == 'em' && value.indexOf('px') !== -1) {
        const fontSize = $self.find(targetSelector).css('font-size');
        try {
          const val = parseInt(value) / parseInt(fontSize);
          value = val.toFixed(2) + 'em';
        } catch (e) {
          // eslint-disable-next-line no-console
          console.log('fail to convert px to em');
        }
      }
      if (this.setting.property == 'width' && this.setting.unit == '%' && value.indexOf('px') !== -1) {
        const $target = $self.find(targetSelector);
        value = getWidthPercentage($target) + '%';
      }
    } else {
      const $target = $self.find(targetSelector);
      value = $target.css(this.setting.property);
      if (value && value.includes('rgb')) {
        value = HELPER.rgb2hex(value);
      }
    }
    if (value === undefined || value === '') {
      value = '';
      options.$activePanel.find(`[name="${this.setting.name}"]`).attr('default_value', value).trigger('value-change');
    }
    options.$activePanel.find(`[name="${this.setting.name}"]`).attr('value', value).val(value).trigger('value-change');
    return { value: value };
  }

  /**
   * write
   * @param value value
   * @param options options
   * @param options.screenType screenType
   * @returns style
   */
  write(
    value: string,
    options: {
      screenType: any;
      $atom: JQuery;
      atomModel: AtomModel;
    },
  ) {
    this.set$el(options.$atom);
    this.setAtomModel(options.atomModel);
    const targetSelector = this.setting.targetSelector as string;

    const $self = this.getAtomTarget('write', this);
    let style = options.atomModel.style;
    const refreshType = this.setting.refreshType ? this.setting.refreshType : 'css';
    if (!targetSelector) {
      alert(`Thiếu targetSelector: ${this.setting.name}`);
    } else {
      if (this.setting.options?.length) {
        for (let i = 0; i < this.setting.options.length; i++) {
          const option = this.setting.options[i];
          if (option.key == value) {
            value = option.value;
          }
        }
      }
      const deOptions = [
        {
          key: this.setting.property,
          value: value,
        },
      ];
      style = HELPER.designOptions2Style($self, options.screenType, style, deOptions, targetSelector);
    }
    return {
      refreshType: refreshType,
      style: style,
    };
  }
  /**
   * getAtomModel
   * @returns atomModel :jQuery
   */
  getAtomModel() {
    return this.atomModel;
  }
}

/**
 *
 */
export class ShCssWidth extends BaseSettingHandler {
  /**
   * read css:dynamic-product
   * @param options options
   * @param options.$atom $atom
   * @param options.style style
   * @param options.screenType screenType
   * @param options.$activePanel $activePanel
   */
  read(options: { $atom: JQuery; screenType: string; atomModel: AtomModel; $activePanel: JQuery }) {
    if (!(options.$activePanel && options.$atom)) {
      return;
    }
    if (!this.setting.targetSelector) {
      alert(`Thiếu targetSelector: ${this.setting.name}`);
    } else {
      const style = options.atomModel.style;
      let width = HELPER.getValueFromCSS(
        options.$atom,
        style,
        'width',
        options.screenType,
        this.setting.targetSelector,
      );
      const $module = options.$atom.children('.module');
      if (width == '' || width == 'none') {
        width = $module.css('width');
      }
      let percentWidth = getWidthPercentage($module).toString();
      if (percentWidth) {
        percentWidth += '%';
      } else {
        percentWidth = width;
      }
      options.$activePanel
        .find('input[name="width"]')
        .val(percentWidth)
        .attr('value', percentWidth)
        .trigger('value-change');
    }
  }

  /**
   * * write css:dynamic-product
   * @param value new value
   * @param options options
   * @param options.$atom $atom
   * @param options.atomModel atomModel
   * @param options.style style
   * @param options.setting setting
   * @param options.screenType screenType
   * @returns returns
   */
  write(
    value: any,
    options: {
      $atom: JQuery;
      atomModel: AtomModel;
      screenType: any;
    },
  ) {
    const deOptions = [
      {
        key: 'width',
        value,
      },
    ];
    const $module = options.$atom.find('.module');
    let style = options.atomModel.style;
    style = HELPER.designOptions2Style($module, options.screenType, style, deOptions, '.module');
    return {
      refreshType: 'css',
      style,
    };
  }
}
